import { Typography } from "antd";
import { CollegeProfile } from "./CollegeProfile";
import "./CollegeProfile.css";

const { Text } = Typography;

export const CollegePage = ({ data }) => {
  if (!data) return <Text>No data available.</Text>;

  return <CollegeProfile data={data} />;
};
